import React from 'react'

import LoginBg from '../../assets/images/LoginBg.jpg';
import Refundpage1 from '../../assets/images/Refundpage1.jpg';
import { Link } from 'react-router-dom';


const Refund = () => {

  return (
    <>
      <section className='AllpageheaderSection'>
        <div className='AllpageheaderSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <h6><Link to='/'><i className='fas fa-home'></i> Home</Link> <span className='PageHead'>REFUND & CANCELLATION POLICY</span></h6>
            </div>
          </div>
        </div>
      </section>
      <section className='AboutusPageSection'>
        <div className='AboutusPageSectionBg' style={{ backgroundImage: `url(${LoginBg})` }}></div>
        <div className='container'>
          <div className='row'>
            <div className='col-md-7 col-sm-7 col-xs-12'>
              <h2>Refund & Cancellation Policy</h2>
              <p>
                <ul>
                  <li>Cancellation shall be done only prior to despatches and after cancellation of excise transport permit.  </li>
                  <li>Refund shall be done after the approval of the competent authority</li>
                  <li>Replacement of item sold due to complaints regarding quality, quantity, or packing will be made only after OIDC officers certify the genuineness of such complaints.</li>
                  <li>No replacement will be provided for products after their expiry date.</li>
                  <li>The retail licencee is responsible for carefully verifying and checking the quantity and condition of the products upon receipt</li>
                  <li>Any shortages or damage must be noted on the Goods Transport Receipt (GTR) and signed by the vehicle driver.</li>
                  <li>Any discrepancies or damage must be immediately reported to OIDC in writing.</li>
                  <li>A weighing scale must be available in the godown.</li>
                </ul>
              </p>
            </div>

            <div className='col-md-5 col-sm-5 col-xs-12'>
              <div className='Aboutuspageimg'>
                <img src={Refundpage1} alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Refund